import { Input, Box, Text, Skeleton } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Search2Icon } from '@chakra-ui/icons';
import { find } from 'lodash';

import { ConditionalComponent, IterationComponent } from '@components/functionComponent';
import FloatingInfo from '@components/floatingInfo';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { ChevronDownThickIcon, CloseIcon } from '@assets/icons';
import { getSelectedFilterName } from './helpers/utils';
import { initialState, dummyFilterList } from './const';
import { updateSelectedFilter } from './helpers/events';
import { debounce } from '@helpers/utils';
import './styles.scss';

const FilterSearch = ({
    placeholder,
    options,
    maxFilter,
    onFetchData,
    isLoading,
    filterId,
    onSelect,
    onSearchQuery,
    searchQuery,
    onClose,
}) => {
    const { onChangeSnackbarNotification } = useSnackbarNotification();
    const [state, setState] = useState(initialState);
    const { isOpen, selectedFilter, filterList, onInputMode } = state;

    const showSelectedFilter = getSelectedFilterName({ selectedFilter });
    const onChangeState = (newState) => setState({ ...state, ...newState });
    const onSearch = debounce((query) => onSearchQuery(query));

    const onUpdateSelectedFilter = ({ selectedFilter, item }) =>
        updateSelectedFilter({
            selectedFilter,
            item,
            onChangeSnackbarNotification,
            maxFilter,
            onChangeState,
            onSelect,
            options,
        });

    const onResetFilter = () => {
        onChangeState({ ...initialState, filterList: options });
        onSelect({ selected: [] });
    };
    useEffect(() => {
        if (options?.length >= 0) onChangeState({ filterList: [...options] });
        // eslint-disable-next-line
    }, [options]);

    useEffect(() => {
        if (isOpen) onFetchData({ searchQuery });
        else {
            document.getElementById(`${filterId}-input`).value = '';
            onClose();
        }
        // eslint-disable-next-line
    }, [isOpen, searchQuery]);

    return (
        <OutsideClickHandler onOutsideClick={() => onChangeState({ isOpen: false, query: '' })}>
            <Box className="filter-search__container" id={filterId}>
                <FloatingInfo label={showSelectedFilter} position={'top'}>
                    {/* //====================FILTER BUTTOn =============== */}

                    <Box className={`filter-button ${isOpen && 'filter-button__actived'}`}>
                        <Box onClick={() => onChangeState({ isOpen: true })} data-testid="filter-search-button__global">
                            {/* //====================SEARCH INPUT =============== */}

                            <ConditionalComponent statement={selectedFilter?.length}>
                                <Text className="filter-selected__number">{selectedFilter?.length}</Text>
                            </ConditionalComponent>

                            <Input
                                data-testid="filter-search__global"
                                paddingLeft={selectedFilter?.length > 0 ? '38px !important' : '16px !important'}
                                className={selectedFilter?.length && 'input-container__selectedfilter'}
                                placeholder={isOpen ? 'Search...' : placeholder}
                                onChange={(e) => onSearch(e.target.value)}
                                onFocus={() => onChangeState({ onInputMode: true })}
                                onBlur={() => onChangeState({ onInputMode: false })}
                                pointerEvents={onInputMode ? 'none' : 'pointer'}
                                id={`${filterId}-input`}
                            />

                            {/* //==================== CHEVRONDOWN ICON =============== */}
                            <ConditionalComponent statement={selectedFilter?.length === 0 && !onInputMode}>
                                <Box className="icon-container">
                                    <ChevronDownThickIcon color="grey" />
                                </Box>
                            </ConditionalComponent>

                            {/* //==================== SEARCH ICON =============== */}

                            <ConditionalComponent statement={onInputMode}>
                                <Box className="icon-container">
                                    <Search2Icon className="search-icon" color="grey" />
                                </Box>
                            </ConditionalComponent>
                        </Box>

                        {/* //==================== RESET ICON =============== */}

                        <ConditionalComponent statement={selectedFilter?.length && !onInputMode}>
                            <Box className="icon-container" cursor="pointer">
                                <CloseIcon color="grey" onClick={onResetFilter} />
                            </Box>
                        </ConditionalComponent>
                    </Box>
                </FloatingInfo>

                {/* //==================== FILTER LIST =============== */}

                <ConditionalComponent statement={isOpen}>
                    <Box className={`filter-list filter-list__actived`}>
                        <IterationComponent
                            arr={isLoading ? dummyFilterList : filterList}
                            render={(item) => (
                                <Box
                                    key={item?.id}
                                    className={`filter-item ${
                                        find(selectedFilter, { id: item?.id }) && 'filter-selected'
                                    } `}
                                    onClick={() =>
                                        onUpdateSelectedFilter({ selectedFilter: [...selectedFilter], item })
                                    }
                                >
                                    {/* //==================== SKELETON LIST =============== */}

                                    <ConditionalComponent statement={isLoading}>
                                        <Skeleton
                                            h="18px"
                                            w="100%"
                                            borderRadius="6px"
                                            startColor="var(--main-color-light-active)"
                                            endColor={`rgba(var(--main-color-light-active),0.5)`}
                                        />
                                    </ConditionalComponent>

                                    {/* //==================== FILTER ITEM =============== */}

                                    <ConditionalComponent statement={!isLoading}>
                                        <Text className="filter-text">{item?.name}</Text>
                                        <Box className="circle-active" />
                                    </ConditionalComponent>
                                </Box>
                            )}
                        />
                        <ConditionalComponent statement={filterList?.length === 0 && !isLoading}>
                            <Text className="empty-text">Filter Not Found</Text>
                        </ConditionalComponent>
                    </Box>
                </ConditionalComponent>
            </Box>
        </OutsideClickHandler>
    );
};

export default FilterSearch;
